import { css } from 'styled-system/css';
import { visuallyHidden } from 'styled-system/patterns';

export const Styles = {
	videoBar: css({
		_mars: {
			'& .symbol': {
				backgroundColor: 'whiteOpacity.70',
			},
			'& button.btn': {
				_hover: {
					'& .symbol': {
						bgColor: 'whiteOpacity.100',
					},
				},
			},
			'& .btn--icon': {
				_active: {
					'& .icon--pin': {
						color: 'warning.base',
						filter: 'drop-shadow(0 0 9px token(colors.warning.base))'
					}
				}
			},
			'& .dropdown__btn': {
				backgroundColor: 'transparent',
				boxShadow: 'inset 0 0 0 1px {colors.whiteOpacity.54}',
				borderRadius: '6px',
				height: '27px',
			},
			'& .icon--dropdown': {
				color: 'whiteOpacity.100',
			},
			'& .dropdown__current': {
				color: 'whiteOpacity.100',
			},
			'& .dropdown__container': {
				backgroundColor: 'var(--s400)',
			},
			'& .dropdown__item[data-selected=true]': {
				color: 'brand.500_light',
				backgroundColor: 'transparent',
				'& .icon': {
					color: 'brand.500_light',
				},
			},
			'& .dropdown__item .icon': {
				color: 'black.1',
			},
		},
		// 當 streaming 尚未播放時
		'.video[data-streaming="false"] &': {
			_mars: {
				'& .video__col--middle': {
					justifyContent: 'center',
					alignItems: 'center',
					overflow: 'hidden',
					width: '100%',
					gap: '3px',
					'& .video__col:empty': {
						display: 'none',
					},
					'& button.btn': {
						flex: '0 1 auto',
						overflow: 'hidden',
						width: 'auto',
						padding: '6px',
						margin: '0',
						gap: '3px',
						border: '1px solid {colors.whiteOpacity.30}',
						// '& .symbol': {
						// 	color: 'whiteOpacity.70',
						// },
						'& .btn__text': {
							flex: '1 1 auto',
							textAlign: 'left',
							color: 'whiteOpacity.100',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
						},
						_hover: {
							border: '1px solid {colors.whiteOpacity.100}',
						},
					}
				},
				'& .video__col:empty': {
					display: 'none',
				},
			},
		},
		// 當 streaming 開始播放時
		'.video[data-streaming="true"] &': {
			'& .video__col--middle': {
				'& .btn__text': {
					display: 'none',
				}
			},
		},
	}),
	hidden: css({
		// _mars: {
		display: 'none',
		'& + .video-lobby': {
			marginTop: '9px',
		},
		// },
	}),
}